import React from "react";
import ContainerWrapper from "./ContainerWrapper";
import PharmaciesMain from "Components/Pharmacy/PharmaciesMain";
// const PharmaciesMain = React.lazy(() =>
//   import("Components/Pharmacy/PharmaciesMain")
// );
const Pharmacies = () => {
  return (
    // <ContainerWrapper>
    <PharmaciesMain />
    // </ContainerWrapper>
  );
};

export default Pharmacies;
